export const DEFAULT_SIDEBAR_SIZE = 66;
export const DEFAULT_TEAMS_SIDEBAR_SIZE = 80;
